import { useEffect, useRef } from 'react';

interface HookParams {
    onVersionChanged: (params?: { newVersion: number }) => void;
}

const checkVersion = async () => {
    try {
        const response = await fetch(`/release.json?t=${Date.now()}`, { cache: 'no-store' });
        if (response.ok) {
            const releaseInfo = await response.json();
            return Number(releaseInfo.version);
        }
    } catch (error) {
        // no catch
    }
    return 0;
};

const useCheckBuildVersionUpdated = ({ onVersionChanged }: HookParams) => {
    const currentVersion = useRef(Date.now());

    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (document.visibilityState === 'visible') {
                const newVersion = await checkVersion();
                if (newVersion > currentVersion.current) {
                    currentVersion.current = newVersion;
                    onVersionChanged({ newVersion });
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleVisibilityChange);
        };
    }, [onVersionChanged]);
};

export default useCheckBuildVersionUpdated;
